export const OrderBOFilter = {
  labelPlaceholder: 'Nº do Pedido BO'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/OrderBOFilter.js